var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mImgEmpty",
    class: _vm.isMobile && 'wap'
  }, [_c('svg-icon', {
    attrs: {
      "name": "img-empty"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };